import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as COMSCORE } from '@zg-rentals/comscore';

export const analytics = defineAnalytics({ COMSCORE });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');
